<template style="width: 1500px;">
    <div id="viewSignCategoryLoadingDiv" class="vs-con-loading__container" >
        <vs-table :sst="true"
            class="w-full"
            @search="handleSearch"
            @change-page="handleChangePage"
            @sort="handleSort"
            v-model="selected"
            :data="sign_categories">

            <template slot="header">
                <div class="flex flex-wrap items-center w-full mb-2">
                    <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus-circle" @click="addSignCategory">Add a SignCategory</vs-button>
                </div>
            </template>

            <template slot="thead">
                <vs-th >Name</vs-th>
                <vs-th >Action</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].name">
                        {{data[indextr].name}}
                    </vs-td>
                    <vs-td>
                        <vs-row>
                            <vs-button @click="editSignCategory(data[indextr])" class="mr-2" color="primary" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                            <vs-button @click="deleteSignCategory(data[indextr])" color="danger" type="filled" icon-pack="feather" icon="icon-trash"></vs-button>
                        </vs-row>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <vs-popup  classContent="popup-example h-full" title="Delete Sign Category" :active.sync="activePromptDeleteignCategory">
            <div id="deleteSignCategoryLoadingDiv" class="vs-con-loading__container">
                <div class="vx-row mb-4">
                    <div class="vx-col w-full mb-2">
                        Are you sure to delete this data ?
                    </div>
                </div>

                <div align="right" class="vx-row">
                    <div  class="vx-col w-full mb-2">
                        <vs-button  v-on:click.prevent="acceptDeleteSignCategory()" color="primary" type="filled"> Confirm</vs-button>
                    </div>
                </div>
         
            </div>
        </vs-popup>

        <vs-popup  classContent="popup-example h-full" title="Add Sign Category" :active.sync="activePromptAddSignCategory">
            <div id="createSignCategoryLoadingDiv" class="vs-con-loading__container">
                <form data-vv-scope="addSignCategoryForm">
                    <div class="vx-row mb-4">
                        <div class="vx-col w-full mb-2">
                            <vs-input v-validate="'required'" label="Sign Category name" name="name" v-model="create_sign_category.name" class="mt-5 w-full" />
                            <span class="text-danger text-sm" v-show="errors.has('addSignCategoryForm.name')">{{ errors.first('addSignCategoryForm.name') }}</span>
                        </div>
                    </div>

                    <div align="right" class="vx-row">
                        <div  class="vx-col w-full mb-2">
                            <vs-button  v-on:click.prevent="createSignCategory()" color="primary" type="filled">Create Sign Category</vs-button>
                        </div>
                    </div>
                </form>
            </div>
        </vs-popup>

        <vs-popup  classContent="popup-example h-full" title="Edit Sign Category" :active.sync="activePromptEditSignCategory">
            <div id="editSignCategoryLoadingDiv" class="vs-con-loading__container">
                <form data-vv-scope="editSignCategoryForm">
                    <div class="vx-row mb-4">
                        <div class="vx-col w-full mb-2">
                            <vs-input v-validate="'required'" label="SignCategory name" name="name" v-model="update_sign_category.name" class="mt-5 w-full" />
                            <span class="text-danger text-sm" v-show="errors.has('editSignCategoryForm.name')">{{ errors.first('editSignCategoryForm.name') }}</span>
                        </div>
                    </div>

                    <div align="right" class="vx-row">
                        <div  class="vx-col w-full mb-2">
                            <vs-button  v-on:click.prevent="updateSignCategory()" color="primary" type="filled">Update SignCategory</vs-button>
                        </div>
                    </div>
                </form>
            </div>
        </vs-popup>

        <div class="vx-row mt-base">
            <div class="vx-col w-full mb-2">
                <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import moduleQuestionManagement from '@/store/question-management/moduleQuestionManagement.js'

export default {
    components: {

    },
    data() {
        return {
            selected:[],
            key : null, 
            active : null,
            search : null,
            totalPage: 1,
            currentPage: 1,
            sign_categories: [],
            deleteSignCategoryData : null,
            selected_place_name : null,
            selected_place_location : null,
            selected_place_type : "all",
            place_types : [
                { id : 'all', label : 'All' },
                { id : 'place', label : 'SignCategory' },
                { id : 'event', label : 'Event' },
                { id : 'tip', label : 'Tip' },
            ],
            activePromptAddSignCategory : false,
            activePromptEditSignCategory : false,
            activePromptDeleteignCategory : false,
            image : [],
            fileRecordsForUpload: [],
            create_sign_category : {
                name : null,
            },
            update_sign_category : {
                id : null,
                name : null,
            },
        }
    },
    watch: {
        currentPage(val) {
            this.searchSignCategorys()
        }
    },
    async mounted() {
        await this.viewSignCategorys() 
        this.sign_categories = this.$store.state.questionManagement.sign_categories
    },
    methods: {
        manageSignCategorys(){
            this.sign_categoriesPopUp = true
        },
        redirectToAppPath(path){
            window.open(path, "_blank");
        },
        addSignCategory() {
            this.activePromptAddSignCategory = true;
        },
        createSignCategory(){
            this.$validator.validateAll('addSignCategoryForm').then(result => {
                if (result) this.createSignCategoryApi()
            })
        },
        createSignCategoryApi(){
            var self = this 
            this.$vs.loading({
              container: '#createSignCategoryLoadingDiv',
              scale: 0.6
            })

            let data = new FormData();
            data.append('name', this.create_sign_category.name);

            this.$store.dispatch("questionManagement/createSignCategory", data)
                .then(res => { 
                    this.$vs.loading.close('#createSignCategoryLoadingDiv > .con-vs-loading')
                    this.$vs.notify({
                        title: "Success.",
                        text: "Sign Category created successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });

                    this.activePromptAddSignCategory = false;
                })
                .catch(err => { 
                    this.$vs.loading.close('#createSignCategoryLoadingDiv > .con-vs-loading')

                    Object.keys(err.data.errors).forEach(function(key) {
                        self.errors.add({
                            field: key,
                            scope: "addSignCategoryForm",
                            msg: err.data.errors[key][0],
                        });
                    });
                })
        },
        editSignCategory(sign) {
            this.update_sign_category = sign;
            this.activePromptEditSignCategory = true
        },
        updateSignCategory(){
            this.$validator.validateAll('editSignCategoryForm').then(result => {
                if (result) this.updateSignCategoryApi()
            })
        },
        updateSignCategoryApi(){
            var self = this 
            this.$vs.loading({
              container: '#editSignCategoryLoadingDiv',
              scale: 0.6
            })

            let data = new FormData();
            data.append('id', this.update_sign_category.id);
            data.append('name', this.update_sign_category.name);

            this.$store.dispatch("questionManagement/updateSignCategory", data)
                .then(res => { 
                    this.$vs.loading.close('#editSignCategoryLoadingDiv > .con-vs-loading')
                    this.$vs.notify({
                        title: "Success.",
                        text: "Sign Category updated successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });

                    this.activePromptEditSignCategory = false;
                })
                .catch(err => { 
                    this.$vs.loading.close('#editSignCategoryLoadingDiv > .con-vs-loading')

                    Object.keys(err.data.errors).forEach(function(key) {
                        self.errors.add({
                            field: key,
                            scope: "editSignCategoryForm",
                            msg: err.data.errors[key][0],
                        });
                    });
                })
        },
        deleteSignCategory(place) {
            this.deleteSignCategoryData = place;
            this.activePromptDeleteignCategory = true;
            // this.$vs.dialog({
            //     type: 'confirm',
            //     color: 'danger',
            //     title: `Confirm`,
            //     text: 'Are you sure to delete this data ?',
            //     accept: this.acceptDeleteSignCategory
            // })
        },
        acceptDeleteSignCategory() {
            this.$vs.loading();

            this.$store.dispatch("questionManagement/deleteSignCategory", { id : this.deleteSignCategoryData.id})
                .then(res => { 
                    this.$vs.loading.close()
                    this.activePromptDeleteignCategory = false;
                    this.$vs.notify({
                        title: "Success.",
                        text: "Sign Category deleted successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });
                })
                .catch(err => { 
                  this.$vs.loading.close()
                })
        },
        
        
        handleSearch(searching) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.search = searching
                this.searchSignCategorys()
            }, 2000);   
        },
        handleChangePage(page) {
            // this.searchUser()
        },
        handleSort(key, active) {
            if(key){
                this.key = key
                this.active = active
                this.searchSignCategorys()
            }
        },
        async searchSignCategorys() {
            var self = this
            this.$vs.loading({
                container: '#viewSignCategoryLoadingDiv',
                scale: 0.6
            })

            let data = { 
                name : this.selected_place_name, 
                location : this.selected_place_location, 
                sort : this.key, 
                sort_key : this.active, 
                page : this.currentPage,
                place_type : this.selected_place_type,
            }

            await this.$store.dispatch("questionManagement/viewSignCategory", data)
                .then(res => { 
                    this.totalPage = res.data.last_page
                    this.$vs.loading.close('#viewSignCategoryLoadingDiv > .con-vs-loading')
                })
                .catch(err => { 
                    this.$vs.loading.close('#viewSignCategoryLoadingDiv > .con-vs-loading')
                })

                this.sign_categories = this.$store.state.questionManagement.sign_categories
        },
        async viewSignCategorys() {
            var self = this

            await this.$store.dispatch("questionManagement/viewSignCategory", {page : this.currentPage})
                .then(res => { 
                    this.totalPage = res.data.last_page
                })

            this.sign_categories = this.$store.state.questionManagement.sign_categories
        },
    },
    async created() {
        if(!moduleQuestionManagement.isRegistered) {
            this.$store.registerModule('questionManagement', moduleQuestionManagement)
            moduleQuestionManagement.isRegistered = true
        }

        
    },
}
</script>
<style type="text/css">
::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}

.vs-con-textarea{
    height: 400px;
}

.vs-textarea {
    height: 100%;
}

</style>

